// Lightweight UK phone-number validation to keep captured numbers clean & callable.
export function isValidUKPhone(input) {
  if (!input) return false;
  let s = String(input).replace(/[\s().-]/g, '');
  s = s.replace(/^\+?44/, '0'); // normalise +44 / 44 to national 0 prefix
  return /^0\d{9,10}$/.test(s); // 0 followed by 9-10 digits (10-11 total)
}

export const UK_PHONE_ERROR = 'Please enter a valid UK phone number (e.g. 07123 456789 or 01702 831975)';
